import axios from '@/libs/axios';
import { useQuery } from '@tanstack/react-query';

//
const request = data => {
  return axios.post('/bill/statistics', data);
};

export const useBills = ({
  id,
  config
}) => {
  return useQuery({ ...config,
    enabled: !!id,
    queryKey: ['user-bills', id],
    queryFn: () => request({
      user_id: id
    })
  });
};